import { useState } from "preact/hooks";
import IconMenu from "tabler-icons/menu-2.tsx";
import IconX from "tabler-icons/x.tsx";

export function HamburgerButton() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = (e: Event) => {
    e.stopPropagation();
    e.preventDefault();

    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <button
      class="hamburger-button"
      onClick={toggleMenu}
      aria-label="Toggle menu"
      data-menu-open={isMenuOpen}
    >
      {isMenuOpen ? <IconX height={24} /> : <IconMenu height={24} />}
    </button>
  );
}
